import React, {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CardComponent} from "../../../components";
import {SET_NEXT_PAGE, SET_SECTION_FLAG_ACTION} from "../../../redux/actions";

const DebtsSummary = () => {
  const dispatch = useDispatch();
  const navigateNext = useCallback((state, edit, applicant) => dispatch(SET_NEXT_PAGE(state, edit, applicant)), [dispatch]);
  const setSectionFlag = useCallback((section, flag) => dispatch(SET_SECTION_FLAG_ACTION(section, flag)), [dispatch]);
  const applicants = useSelector( state => state.wizardStore.model.applicants);
  const currentApplicant = useSelector( state => state.wizardStore.meta.currentApplicant);
  const totalApplicants = useSelector( state => state.wizardStore.meta.totalApplicants);
  const applicantIndex = parseInt(currentApplicant.toString());
  const applicant = applicants[applicantIndex];
  const total = parseInt(totalApplicants.toString());

  const _continueHandler = () => {
    if (applicantIndex < total - 1) {
      navigateNext("debts_permission_question", false, applicantIndex + 1);
    } else {
      setSectionFlag("debts", true);
      navigateNext("declarations_statements_first", false, 0);
    }
  };

  const _editHandler = (state) => {
    navigateNext(state, true, applicantIndex);
  };

  return (
    <CardComponent title={`${applicant.firstName}'s Debt Summary`}>
      <div className="flex flex-col items-start max-w-xl">
        {
          (applicant && applicant.isDebtPermissionGranted != null) &&
          <div className="flex items-center justify-between mb-3 w-full">
            <span className="cp-font-r14w300g800">Permission to Access Credit</span>
            <button className="cp-btn-review" onClick={() => _editHandler("debts_permission_question")}>
              Edit
            </button>
          </div>
        }
        {
          (applicant && applicant.socialSecurityNumber != null) &&
          <div className="flex items-center justify-between mb-3 w-full">
            <span className="cp-font-r14w300g800">Social Security Number</span>
            <button className="cp-btn-review" onClick={() => _editHandler("debts_ssn_info")}>
              Edit
            </button>
          </div>
        }
        {
          (applicant && applicant.otherDebts != null) &&
          <div className="flex items-center justify-between mb-3 w-full">
            <span className="cp-font-r14w300g800">Other Debts</span>
            <button className="cp-btn-review" onClick={() => _editHandler("debts_other_obligations")}>
              Edit
            </button>
          </div>
        }
      </div>
      <div className="flex flex-col items-center max-w-xl">
        <button className="cp-btn-primary" onClick={() => _continueHandler()}>
          Continue
        </button>
      </div>
    </CardComponent>
  )
};

export default DebtsSummary;
